import { ReactNode } from 'react';
import { CoreBox, CoreTypography } from '@youscience/core';
import ChevronRight from '@images/chevron-right.svg?react';
import { StyledCardWrap, sxStyles } from './NavigationCard.styles';

interface NavigationCardProps {
  icon: ReactNode;
  title: string;
  navigationUrl: string;
  isOpenInNewTab?: boolean;
  onClick?: () => void | Promise<void>;
}

export const NavigationCard = (props: NavigationCardProps) => {
  const { icon, title, navigationUrl, isOpenInNewTab = false, onClick } = props;

  return (
    <StyledCardWrap
      to={navigationUrl}
      data-testid="cardWrap"
      target={isOpenInNewTab ? '_blank' : undefined}
      rel={isOpenInNewTab ? 'noreferrer' : undefined}
      onClick={onClick}
    >
      <CoreBox sx={sxStyles.titleWrap}>
        <CoreBox data-testid="icon" sx={sxStyles.icon}>
          {icon}
        </CoreBox>

        <CoreTypography data-testid="title" variant="subtitle1" component="h2">
          {title}
        </CoreTypography>
      </CoreBox>

      <ChevronRight />
    </StyledCardWrap>
  );
};
